const pugpigPianoStrongSecurityInApp = function() {
  return window.location.protocol.search(/http(s)?/) === -1;
}

const PugpigPianoStrongSecurity = () => {
  let verifyInFlight = null;
  let signOutInFlight = null;

  function getVerifyBaseUrl() {
    const verifyMeta = document.querySelector("meta[property='pugpig:access:piano:verify-base-url']");
    if (!verifyMeta) {
      return null;
    }

    const verifyBaseUrl = new URL(verifyMeta.getAttribute('content'), window.location.origin);
    if (!verifyBaseUrl.pathname.endsWith('/')) {
      verifyBaseUrl.pathname += '/';
    }

    if (verifyBaseUrl.origin !== window.location.origin) {
      console.error('Pugpig Piano verify URL must use the same origin as the website.');
      return null;
    }

    return verifyBaseUrl;
  }

  function getSubsUrl(action) {
    const verifyBaseUrl = getVerifyBaseUrl();
    return verifyBaseUrl ? new URL(action, verifyBaseUrl) : null;
  }

  function isPaidPage() {
    const accessMeta = document.querySelector("meta[property='pugpig:access']");
    return accessMeta && accessMeta.getAttribute('content') === 'paid';
  }

  function serverRenderedFullArticle() {
    const sample = document.querySelector('.pp-subs__post-start[data-show-fade-on-noaccess]');
    const rest = document.querySelector('.pp-subs__post-end[data-show-has-access]');

    return !sample || rest !== null;
  }

  function reloadMarkerKey() {
    return 'pugpig-piano-verify-reload:' + window.location.pathname;
  }

  function reloadForServerAccess(hasAccess) {
    if (!isPaidPage()) {
      return;
    }

    const renderedFullArticle = serverRenderedFullArticle();
    const markerKey = reloadMarkerKey();

    if (renderedFullArticle === hasAccess) {
      sessionStorage.removeItem(markerKey);
      return;
    }

    const expectedState = hasAccess ? 'access' : 'noaccess';
    if (sessionStorage.getItem(markerKey) === expectedState) {
      console.error('Pugpig Piano did not receive the expected server-rendered access state after reloading.');
      return;
    }

    sessionStorage.setItem(markerKey, expectedState);
    window.location.reload();
  }

  function parseVerifyState(responseText) {
    const responseXml = new DOMParser().parseFromString(responseText, 'application/xml');
    const subscription = responseXml.querySelector('subscription');
    return subscription ? subscription.getAttribute('state') : null;
  }

  function setUserAccess(hasAccess) {
    document.body.dataset.unknownAccess = false;
    document.body.dataset.hasAccess = hasAccess;
  }

  function verifySubscription(token) {
    const verifyUrl = getSubsUrl('verify_subscription');
    if (!verifyUrl || !token) {
      return Promise.resolve(null);
    }

    if (verifyInFlight) {
      return verifyInFlight;
    }

    const formData = new FormData();
    formData.append('token', token);

    verifyInFlight = fetch(verifyUrl, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Verify subscription returned HTTP ' + response.status);
        }
        return response.text();
      })
      .then(responseText => {
        const state = parseVerifyState(responseText);
        if (!state) {
          throw new Error('Verify subscription returned an invalid response');
        }

        const hasAccess = state === 'active';
        setUserAccess(hasAccess);
        reloadForServerAccess(hasAccess);
        return state;
      })
      .catch(error => {
        setUserAccess(false);
        console.error('Pugpig Piano verify subscription failed', error);
        return null;
      })
      .then(state => {
        verifyInFlight = null;
        return state;
      });

    return verifyInFlight;
  }

  function clearVerifiedSubscription() {
    const signOutUrl = getSubsUrl('sign_out');
    if (!signOutUrl) {
      return Promise.resolve(false);
    }

    if (signOutInFlight) {
      return signOutInFlight;
    }

    signOutInFlight = fetch(signOutUrl, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      keepalive: true,
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Sign out returned HTTP ' + response.status);
        }
        return true;
      })
      .catch(error => {
        console.error('Pugpig Piano server sign out failed', error);
        return false;
      })
      .then(cleared => {
        signOutInFlight = null;
        if (cleared && isPaidPage() && serverRenderedFullArticle()) {
          window.location.reload();
        }
        return cleared;
      });

    return signOutInFlight;
  }

  // Piano replaces its initial queue with the SDK. Resolve window.tp inside
  // callbacks rather than retaining the queue captured before the SDK loads.
  window.tp.push(['addHandler', 'loginSuccess', data => {
    const pianoId = window.tp.pianoId;
    const token = data && data.token
      ? data.token
      : pianoId && pianoId.getToken
        ? pianoId.getToken()
        : null;
    verifySubscription(token);
  }]);

  window.tp.push(['init', () => {
    function verifyExistingSession() {
      const pianoId = window.tp.pianoId;
      if (pianoId && pianoId.isUserValid() && pianoId.getToken) {
        verifySubscription(pianoId.getToken());
      }
    }

    // Access reconciliation needs the article markup, not a partially parsed head.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', verifyExistingSession, { once: true });
    } else {
      verifyExistingSession();
    }
  }]);

  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('#pp-subs-logout')) {
      clearVerifiedSubscription();
    }
  }, true);
}

if (!pugpigPianoStrongSecurityInApp() && typeof window.tp !== 'undefined') {
  PugpigPianoStrongSecurity();
}
